import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import { SocietyProviderDataForm, SocietyProviderFilters } from '../../../../app/models/SocietyProvider';
import SocietyProviderFilter from './SocietyProviderFilter';

interface Props {
    societyProviders: SocietyProviderDataForm[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    active?: (id: number, active: boolean) => void;
    show?: (id: number) => void;
    destroy?: (id: number) => void;
    filter: SocietyProviderFilters;
    setFilter: (filter: SocietyProviderFilters) => void;
    paginationRowsPerPageOptions?: any[];
    callbackSuccess: () => void;
}

const SocietyProviderDataTable = ({
    societyProviders,
    totalRows,
    loading = false,
    edit,
    destroy,
    active,
    show,
    filter,
    setFilter,
    callbackSuccess
}: Props) => {
    const columns = [
        {
            name: 'rut',
            selector: (row: any) => row.provider?.rut,
            sortable: true,
            sortField: 'rut',
            cell: (row: SocietyProviderDataForm) => (
                <span>{row.provider?.rut ?? '-'}</span>
            )
        },
        {
            name: 'Razón Social',
            selector: (row: any) => {
                const bn = row.provider?.business_name;
                return typeof bn === 'string' ? bn : bn?.name || '-';
            },
            sortable: true,
            sortField: 'name',
            cell: (row: SocietyProviderDataForm) => {
                const bn = row.provider?.business_name;
                const name = typeof bn === 'string' ? bn : bn?.name;
                return <span>{name ?? '-'}</span>;
            }
        },
        {
            name: 'Nombre Contacto',
            selector: (row: any) => `${row.provider?.first_name_contact} ${row.provider?.last_name_contact}`,
            sortable: true,
            sortField: 'contact_name',
            cell: (row: SocietyProviderDataForm) => (
                <span>
                    {row.provider?.first_name_contact && row.provider?.last_name_contact
                        ? `${row.provider.first_name_contact} ${row.provider.last_name_contact}`
                        : '-'}
                </span>
            )
        },
        {
            name: 'Email Contacto',
            selector: (row: any) => row.provider?.email_contact,
            sortable: true,
            sortField: 'email',
            cell: (row: SocietyProviderDataForm) => (
                <span>{row.provider?.email_contact ?? '-'}</span>
            )
        },
        {
            name: 'Acciones',
            selector: (row: any) => row.id,
            sortable: false,
            cell: (row: SocietyProviderDataForm) => (
                <div>
                    {show && (
                        <ButtonTableAction
                            callbackFunction={() => show(row.id ?? -1)}
                            classIcon={'mdi mdi-eye'}
                            colorIcon={'text-info'}
                            errorMessage={'No se puede mostrar este registro.'}
                            title={'Ver'}
                        />
                    )}
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id ?? -1)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    <SocietyProviderFilter filter={filter} setFilter={setFilter} />
                </div>
            </div>

            <DefaultDataTable
                columns={columns}
                data={societyProviders}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default SocietyProviderDataTable;